// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";

function PilotClozeDropTextContainer(props) {
  return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.DropNoChildren.make, {
              id: props.id,
              containerClassname: "pilotClozeDropSingleContainer",
              containerOverClassname: "pilotClozeDropSingleContainerOver",
              dom: "span",
              elementRef: "span"
            });
}

var make = PilotClozeDropTextContainer;

var $$default = PilotClozeDropTextContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
